import { Button } from 'components/Elements';
import { Form, InputField } from 'components/Form';
import { EyeClosed, Eye } from 'lucide-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { AtSign, Lock } from 'react-feather';
import { login2FA } from '../api/login2FA';
import { parseDeepLink } from 'react-deep-link';
import Cookies from 'js-cookie';
import { FINANCE_APP_URL } from 'config/remotes';

const parsedData = parseDeepLink(new URLSearchParams(window.location.search));

console.log(parsedData)
export const LoginForm = ({ onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          setIsLoading(true);

          const app = parsedData.state?.app || 'finance';
          Cookies.set('app', app, { expires: 5 / 1440 });

          const result = await login2FA(values);

          const cookieData = {
            temp_token: result.token,
            user: result.email,
            allowSMSCodeVerification: result.allowSMSCodeVerification,
            allow2FA: result.allow2FA,
            allowEmailOTPLogin: result.allowEmailOTPLogin,
            allowAuthenticator: result.allowAuthenticator,
            baseUrl: parsedData.baseUrl || FINANCE_APP_URL,
            route: parsedData.state?.redirectPath || '',
            ...parsedData.state,
          };

          const value = JSON.stringify(cookieData);

          Cookies.set('loginData', value, { expires: 5 / 1440 });

          setIsLoading(false);
          onSuccess();
        }}
      >
        {({ register, formState }) => (
          <>
            <InputField
              type="text"
              label="Email"
              startIcon={<AtSign />}
              error={formState.errors['email']}
              registration={register('email')}
              variant="filled"
            />
            <InputField
              type={passwordVisible ? 'text' : 'password'} // Toggle between text and password type
              label="Password"
              startIcon={<Lock />}
              error={formState.errors['password']}
              registration={register('password')}
              endIcon={
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  aria-label="Toggle Password Visibility"
                >
                  {passwordVisible ? <Eye /> : <EyeClosed />}
                </button>
              }
              variant="filled"
            />
            <div>
              <Button isLoading={isLoading} type="submit" className="w-full">
                Sign in
              </Button>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

LoginForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};
